<template>
    <div class="container">
      
    </div>

</template>

<script>
  export default {
    name      : 'app',
    data() {
      return {
      }
    },
    computed:{

    },
    created(){
        // this.$router.push({name:'Monitor'});
    },
    mounted(){
        let that = this
        setTimeout(function(){
            that.$router.push({name:'Monitor'});
        },10)
    
    },
    methods: {
        
        
    },
    components:{
            
    }
  }
</script>
<style lang='scss'>

</style>